import { useState } from 'react';
import { AccountType } from "shared/types/flowstep";


export const Direction = {
  Up: 'up',
  Down: 'down',
};


export function useModifiedItems(items, getId) {
  const [modifiedItems, setModifiedItems] = useState(getInitialState(items));

  function getInitialState(items) {

    return {modified: [...items], removed: [], areMoved: false};
  }

  function removeItem(data) {
    setModifiedItems(old => {
      const modified = [...old.modified];
      const index = modified.findIndex(x => getId(x) === getId(data));
      const removed = [...old.removed, modified.splice(index, 1)[0]];
      return { ...old, modified, removed };
    });
  }

  function moveItem(data, direction) {
    setModifiedItems(old => {
      const modified = [...old.modified];

      const from = modified.findIndex(x => getId(x) === getId(data));
      const to = direction === Direction.Up ? from - 1 : from + 1;

      const temp = modified[to];
      modified[to] = modified[from];
      modified[from] = temp;
      return { ...old, modified, areMoved: true };
    });
  }

  function resetItems(items) {
    setModifiedItems(getInitialState(items));
  }

  return { items: modifiedItems, removeItem, moveItem, resetItems };
}

export function getEditModeButtons({ isFirst, isLast, isDeleteDisabled = false, onMoveClick, onDeleteClick }) {
  return [
    !isFirst
      ? { iconName: 'up', tooltip: 'Move up', onClick: () => onMoveClick(Direction.Up), isLarge: true }
      : null,
    !isDeleteDisabled
      ? { iconName: 'xappex-delete', tooltip: 'Delete', onClick: onDeleteClick }
      : null,
    !isLast
      ? { iconName: 'down', tooltip: 'Move down', onClick: () => onMoveClick(Direction.Down), isLarge: true }
      : null,
  ]
}

export const matchesToProvider = (flowstep, accountType) => {
  const { originalFlowstep } = flowstep;

  if (originalFlowstep) {
    const [providerPlatform] = originalFlowstep.provider.split('/');
    return providerPlatform === accountType;
  }

  return accountType === AccountType.SF;
}
